import { useState, useEffect, DependencyList } from "react";

export function useAnimeKeyWithDep({
  ext = "",
  deps = [],
}: {
  ext?: string;
  deps?: DependencyList;
}): string {
  const [animeKey, setAnimeKey] = useState<string>("");

  useEffect(() => {
    setAnimeKey(`${new Date().getTime()}-${ext}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return animeKey;
}
